<div class="imprint justify-content-between">
    <div class="header">
        <div class="logo">
            <img src="assets/logo/avs.svg" alt="AVS-Portal Logo" height="35">
        </div>
        <div class="logo-underline"></div>
    </div>
    <div class="contentWrapper">
        <div class="card shadow rounded-0 showcase contentCard p-5">
            <h1>Impressum</h1>
            <div class="d-flex flex-column" style="margin-top: 32px;">
                <h2 style="margin-top: 32px; font-weight: bold;">AVS Verkehrssicherung GmbH</h2>
                <span> Marie-Curie-Straße 11</span>
                <span>51377 Leverkusen</span>
            </div>
            <div class="d-flex flex-column" style="margin-top: 32px;">
                <h3>Kontakt</h3>
                <span><b>E-Mail:</b>&nbsp;<a href="mailto:opz@avs.eu"> opz&#64;avs.eu</a></span>
                <span><b>Tel:</b>&nbsp;+49 2597 9608-24 </span>
            </div>
            <div class="d-flex flex-column" style="margin-top: 32px;">
                <h3>Geschäftsführer</h3>
                <span>Elena Vasileva </span> 
                <span>Andreas Schwingeler </span>
                <span>Sebastian Minnich</span> 
                <span>Tobias Schweitzer</span>
            </div>
            <div class="d-flex flex-column" style="margin-top: 32px;">
                <span><b>Umsatzsteuer-Identifikationsnummer gemäß §27a:</b>&nbsp;DE121974312</span>
                <span><b>Handelregistereintrag:</b>&nbsp;Amtsgericht Köln, HRB 46046</span>
            </div>
        </div>
    </div>
    <div>
        <avs-app-footer></avs-app-footer>
    </div>
</div>
